import React from "react";
import { Link } from "@reach/router";
import MaterialTable, { Column } from "@material-table/core";
import { Tooltip } from "@material-ui/core";
import { getTeamByOrgId_organization_team as TeamMember } from "types/gql-types";
import PhoneNumber from "components/phone-number/phone-number";
import { Roles } from "components/auth/types";
import { CopyButton } from "components/haven-design/copy-button";
import { RemoveUser } from "./remove";

// to be used in map on `user.roles` array
const formatRoles = (role: string) => {
  switch (role) {
    case "propManager":
      return "Property Manager";
    case "supervisor":
      return "Supervisor";
    case "client":
      return "Applicant";
    case "admin":
      return "Administrator";
    default:
      return role;
  }
};


// ---- custom columns ----

interface ActionProps {
  rowData: TeamMember;
  value: string;
}

const ActionColumn = (props: ActionProps) => {
  const { rowData } = props;
  const userId: string = props.value;

  return (
    <div style={{ whiteSpace: "nowrap" }}>
      <Link to={`/dash/manager/settings/team/${userId}`}>Edit</Link>
      {" | "}
      <RemoveUser user={rowData} />
    </div>
  );
};

interface TypeProps {
  value: [Roles];
}
const TypeColumn = ({ value }: TypeProps) => {
  const roles = value.map(formatRoles).join(", ");
  return <div>{roles}</div>;
};

// ---- user table ----
interface TableProps {
  rowData: TeamMember[];
}

const emailStyles = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "260px",
  display: "inline-block",
} as React.CSSProperties;

const columns: Array<Column<TeamMember>> = [
  { field: "fullName", title: "Name" },
  { field: "email",
    title: "Email",
    render: ({ email }) => {
      if (!email) return "";
      return <Tooltip title={email}>
        <span style={emailStyles}><CopyButton text={email} />{email}</span>
      </Tooltip>;
    } },
  { field: "directPhone", title: "Phone", render: ({ directPhone }) => <PhoneNumber number={directPhone ?? ""}/> },
  { field: "title", title: "Title" },
  { field: "roles", title: "Account Type", render: ({ roles }) => <TypeColumn value={roles as [Roles]} /> },
  { field: "id", title: "Action", render: (data) => <ActionColumn value={data.id} rowData={data} /> },
];

const TeamTable: React.FC<TableProps> = (props) => {
  const users = props.rowData;
  let pageSize = Math.min(users.length, 250);
  if (pageSize % 10 !== 0) {
    pageSize = pageSize - (pageSize % 10) + 10;
  }
  const division = Math.floor(pageSize / 5);
  return (
    <MaterialTable
      title="Team Settings"
      components={{
        Container: function Container (containerProps) {
          return <div {...containerProps}/>;
        },
      }}
      data={users}
      columns={columns}
      options={{
        showTitle: false,
        pageSize,
        pageSizeOptions: [...Array(pageSize + 1).keys()]
          .filter((num) => num !== 0 && num % division === 0),
      }}
    />
  );
};

export default TeamTable;
